import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Paper,
} from "@material-ui/core/";
import Action from "../Assets/action.png";
import Dashboard from "../Assets/Dashboard.png";
import Performance from "../Assets/Performance.png";
import executiveDashboard from "../Assets/executive_dashboard.png";
import Trends from "../Assets/Tends.png";
import refresh_token from "./../../../Global/refresh_token";
import Colors from "./../../../Global/colors";
import { useHistory } from "react-router-dom";
import GlobalApi from "../../../Global";
import Filter from "../Assets/filter.png";
import { useTranslation } from "react-i18next";

//Redux
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  grid: {
    transition: theme.transitions.create(["background", "background-color"], {
      duration: theme.transitions.duration.complex,
    }),
    "&:hover": {
      backgroundColor: "#f0f2f5",
    },
    cursor: "pointer",
  },
}));

export const TabBar = ({ active, setModal }) => {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const [packageCurrentDetails, setPackageCurrentDetails] = React.useState({});
  const [packageExpired, setPackageExpired] = React.useState(false);
  const [permissions_obj, setPermissionObj] = useState({});
  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    getCurrentPackage();
  }, []);

  useEffect(
    () => {
      getPermissions();
    },
    [company?.id]
  );

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  async function getCurrentPackage() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();
        if (reqJson.package.inspection_request_status === "Request is Valid") {
          setPackageCurrentDetails(reqJson.package);
        } else {
          setPackageCurrentDetails("expired");
          setPackageExpired(true);
        }
      }

  return <div style={{ padding: "0px", width: "100%" }}>
      {/* ++++++++++++++++++For Web */}
      {window.innerWidth > 700 && <div style={{ overflow: "hidden", borderRadius: "10px", backgroundColor: "white", width: "100%", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", position: "relative" }}>
          <div onClick={() => {
              setModal(active, true);
            }} style={{ cursor: "pointer", position: "absolute", right: "5px", justifyContent: "center", display: "flex", alignItems: "center", flexDirection: "column", padding: "10px", height: "100%" }}>
            <img src={Filter} width={30} />
            <p className="filterHeading" style={{ color: "#1E68EC", fontSize: 12, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
              {t("Filter")}
            </p>
          </div>
          <Grid spacing={0 //container
            } direction="row" justify="center" alignItems="center" style={{ display: "flex", flexDirection: "row", borderRight: "1px solid #dadada", marginRight: "60px" }}>
            {/* {!packageExpired && packageCurrentDetails?.title == "Enterprise" && (userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Analytics"] == true) && <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ // display: "flex",
                  // alignItems: "center",
                  paddingTop: "14px", paddingBottom: "10px", height: "100%", backgroundColor: active === "executiveDashboard" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/dashboard")}>
                <Grid container alignItems="center" justify="center" style={{ height: "100%" }}>
                  <Grid item>
                    <img src={executiveDashboard} width={50} />
                  </Grid>
                  <Grid item>
                    <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", alignItems: "center", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                      Executive Dashboard
                    </p>
                  </Grid>
                </Grid>
              </Grid>} */}

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 15, height: "100%", backgroundColor: active === "dashboard" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%" }}>
                <Grid item>
                  <img src={Dashboard} width={40} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 25 : 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Dashboard")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 10, height: "100%", backgroundColor: active === "performance" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/performance")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%" }}>
                <Grid item>
                  <img src={Performance} width={50} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 25 : 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Performance")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 10, height: "100%", backgroundColor: active === "action" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/action")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%" }}>
                <Grid item>
                  <img src={Action} width={50} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 25 : 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Action")}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>}

      {/* ++++++++++++++++++For Tab */}
      {window.innerWidth > 500 && window.innerWidth <= 700 && <div style={{ overflow: "hidden", borderRadius: "10px", backgroundColor: "white", width: "100%", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", position: "relative" }}>
          <div onClick={() => {
              setModal(active, true);
            }} style={{ cursor: "pointer", position: "absolute", right: "5px", justifyContent: "center", display: "flex", alignItems: "center", flexDirection: "column", padding: "10px", height: "100%" }}>
            <img src={Filter} width={30} />
            <p className="filterHeading" style={{ color: "#1E68EC", fontSize: 12, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
              {t("Filter")}
            </p>
          </div>
          <Grid spacing={0 //container
            } direction="row" justify="center" alignItems="center" style={{ display: "flex", flexDirection: "row", borderRight: "1px solid #dadada", marginRight: "60px" }}>
        

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 15, height: "100%", backgroundColor: active === "dashboard" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%" }}>
                <Grid item>
                  <img src={Dashboard} width={30} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 20 : 10, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Dashboard")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 10, height: "100%", backgroundColor: active === "performance" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/performance")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%" }}>
                <Grid item>
                  <img src={Performance} width={30} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ display: "block", paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 20 : 10, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Performance")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 10, height: "100%", backgroundColor: active === "action" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/action")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ flexDirection: "column", height: "100%" }}>
                <Grid item>
                  <img src={Action} width={30} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize: language=='ar' ? 20 : 10, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Action")}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>}

      {/* ++++++++++++++++++For Mobile */}
      {window.innerWidth <= 500 && <div style={{ overflow: "hidden", borderRadius: "10px", backgroundColor: "white", width: "100%", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", position: "relative" }}>
          <div onClick={() => {
              setModal(active, true);
            }} style={{ cursor: "pointer", position: "absolute", right: "5px", justifyContent: "center", display: "flex", alignItems: "center", flexDirection: "column", padding: "5px", height: "100%" }}>
            <img src={Filter} width={20} />
            <p className="filterHeading" style={{ color: "#1E68EC", fontSize: 10, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
              {t("Filter")}
            </p>
          </div>
          <Grid spacing={0 //container
            } direction="row" justify="center" alignItems="center" style={{ display: "flex", flexDirection: "row", borderRight: "1px solid #dadada", marginRight: "45px" }}>
          

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 5, height: "100%", backgroundColor: active === "dashboard" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%",flexDirection:'column' }}>
                <Grid item>
                  <img src={Dashboard} width={20} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize:  language=='ar' ? 18 : 8, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Dashboard")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 5, height: "100%", backgroundColor: active === "performance" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/performance")}>
              <Grid container align="center" alignItems="center" justify="center" style={{ height: "100%",flexDirection:'column' }}>
                <Grid item>
                  <img src={Performance} width={20} />
                </Grid>
                <Grid item>
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize:language=='ar' ? 18 : 8, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Performance")}
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid} align="center" style={{ padding: 5, height: "100%", backgroundColor: active === "action" ? Colors.globalColor9 : null }} onClick={() => history.push("/analytics/action")}>
              <Grid container  align="center" alignItems="center" justify="center" style={{ flexDirection:'column', height: "100%" }}>
                <Grid item>
                  <img src={Action} width={20} />
                </Grid>
                <Grid item >
                  <p className="filterHeading" style={{ paddingLeft: 5, color: "#306086", justifyContent: "left", display: "flex", fontSize:language=='ar' ? 18 : 8, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Action")}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>}
    </div>;
};
